import React, { useCallback, useContext, useState } from 'react';
import clsx from 'clsx';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Dashboard } from './Features/Dashboard';
import { OurLaws } from './Features/OurLaws';
import { OtherRequirements } from './Features/OtherRequirements';
import { Statistics } from './Features/Statistics';
import { Settings } from './Features/Settings/Settings';
import { Grid } from '@material-ui/core';
import { LawPortalSidebar } from './Components/LawPortalSidebar';
import { ModuleContext, useModule } from '../../Context/ModuleContext/ModuleContext';
import { Header } from '../../Components/Header/Header';
import { useStyles } from '../Module.styles';
import { AccessLevel, LawPortalFeature, UserContext } from '../../Context/UserContext/UserContext';
import { LegalComplianceControl } from './Features/LegalComplianceControl';
import { Administration } from './Features/Administration';
import { CreateLawComplianceReport } from "./Features/OurLaws/Law/Compliance/Create";
import { Help } from "./Features/Help";

export const LawPortalModule = () => {
  const classes = useStyles();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { hasAccessToFeature } = useContext(UserContext);
  const accessToOurLaws = hasAccessToFeature(LawPortalFeature.OurLaws, AccessLevel.Read);
  const accessToOtherRequirements = hasAccessToFeature(LawPortalFeature.OtherRequirements, AccessLevel.Read);

  const handleSidebarToggle = useCallback((open: boolean) => {
    setSidebarOpen(open);
  }, []);

  const { Provider } = ModuleContext;
  const module = useModule();

  return (
    <Grid container>
      <Grid item>
        <LawPortalSidebar sidebarOpen={sidebarOpen} handleSidebarToggle={handleSidebarToggle} />
      </Grid>
      <Grid
        item
        className={clsx(classes.content, {
          [classes.contentShift]: sidebarOpen,
        })}
      >
        <Provider value={module}>
          <Header
            sidebarOpen={sidebarOpen}
            handleSidebarToggle={handleSidebarToggle}
            title={module.header}
            subMenu={module.subMenu}
          />
          <Routes>
            <Route path="dashboard" element={<Dashboard />} />
            {accessToOurLaws && <Route path="our-laws/*" element={<OurLaws />} />}
            {accessToOtherRequirements && <Route path="other-requirements/*" element={<OtherRequirements />} />}
            <Route path="administration/*" element={<Administration />} />
            <Route path="statistics/*" element={<Statistics />} />
            <Route path="legal-compliance-control/*" element={<LegalComplianceControl />} />
            <Route path="settings" element={<Settings />} />
            <Route path="help" element={<Help />} />
            <Route path="legal-compliance-control/:id/laws/report" element={<CreateLawComplianceReport />} />
            <Route path="/" element={<Navigate to="dashboard" replace />} />
            <Route path="*" element={<Navigate to="dashboard" replace />} />
          </Routes>
        </Provider>
      </Grid>
    </Grid>
  );
};

export default LawPortalModule;
